<template>
  <div id="app">

<div id="theheader" v-if="showheader">
      <header class="header header--standard header--market-place-4" data-sticky="true">
        <div class="header__top">
            <div class="container">
                <div class="header__left">
                    <p v-if="language.language=='English'"> Your business wise command center !</p>
                    <p v-if="language.language=='Français'">Votre partenaire en logistique !</p>
                </div>
                <div class="header__right">
                    <ul class="header__top-links">
                        <li><a >{{company}}</a></li>
                        <!--
                        <li v-if="language.language=='English'"><a href="#">Track Your Order</a></li>
                        <li v-if="language.language=='Français'"><a href="#"> Suivre votre commande</a></li>
                        -->
                        <li>
                            <div class="ps-dropdown language">
                                <a  v-if="language.language=='English'" href="#"><img src="./assets/img/flag/en.png" alt="">English</a>
                                <a  v-if="language.language=='Français'" href="#"><img src="./assets/img/flag/fr.png" alt="">Francais</a>
                                <ul class="ps-dropdown-menu">
                                    <li v-for="lang in languages" :key="lang.id">
                                        <a v-on:click="change_user_language(lang.value)"><img :src="lang.href" alt="">{{lang.language}}</a>
                                    </li>
                                </ul>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div v-if="showeventmsg" class="snackbar success">
          <p>{{eventmsg}}</p>
        </div>
        <div v-if="showerrormsg"  class="snackbar error">
          <p>{{eventmsg}}</p>
        </div>
        <div class="header__content">
            <div class="container">
                <div class="header__content-left"><a class="ps-logo" href="/#/private"><img src="./assets/img/logo-entreproamd-user.png" alt=""></a>


                </div>
                <div class="header__content-center">
                    <form class="ps-form--quick-search" >

                        <input v-if="isEnglish()==true" class="form-control" v-model="search_obj.word" type="text"  v-on:keydown.enter.prevent='search_product' placeholder="Key word" required>
                        <input v-if="isEnglish()==false" class="form-control" v-model="search_obj.word" type="text"  v-on:keydown.enter.prevent='search_product' placeholder="Mot-clé" required>

                        <button v-if="isEnglish()==true" type="button" v-on:click="search_product()" >Search</button>
                        <button v-if="isEnglish()==false" type="button" v-on:click="search_product()" ><span>Rechercher</span><i class="icon-magnifier"></i></button>
                    </form>


                </div>
                <div class="header__content-right">
                    <div class="header__actions">

                        <div class="ps-cart--mini"><a class="header__extra" href="#"><i class="icon-bag2"></i><span><i>{{cart.length}}</i></span></a>

                            <div class="ps-cart__content" :class="[cart.length >= 1 ? 'showcart' : '']">
                                <div class="ps-cart__items">
                                    <div v-for="item in cart" :key="item.id" class="ps-product--cart-mobile">
                                        <div class="ps-product__thumbnail"><a href="#"><img :src="item.image_url" alt=""></a></div>
                                        <div class="ps-product__content">
                                            <a v-on:click="remove_from_cart(item)" class="ps-product__remove" href="#">
                                                <i  class="icon-cross">
                                                </i>
                                            </a>
                                            <a href="#products">{{item.description}}</a>
                                            <p v-if="isEnglish()==true">Quantity:<strong> {{item.minimum_quantity}}</strong></p>
                                            <p v-if="isEnglish()==false">Quantité:<strong> {{item.minimum_quantity}}</strong></p>

                                        </div>
                                    </div>

                                </div>
                                <div class="ps-cart__footer">
                                    <!-- <h3>Sub Total:<strong>$59.99</strong></h3> -->
                                    <figure v-if="cart.length>0">
                                        <!-- <a class="ps-btn" href="#Cart">View Cart</a> -->
                                        <router-link v-if="isEnglish()==true" class="ps-btn" to="/Cart" >View Cart</router-link>
                                        <router-link v-if="isEnglish()==false" class="ps-btn" to="/Cart" >Voir panier</router-link>
                                        <router-link v-if="isEnglish()==true" class="ps-btn" to="/Checkout" >Order</router-link>
                                        <router-link v-if="isEnglish()==false" class="ps-btn" to="/Checkout" >Commander</router-link>

                                    </figure>
                                </div>
                            </div>
                        </div>
                        <div class="ps-block--user-header" v-if="!loggedin">
                            <div class="ps-block__left">
                            </div>
                            <div class="ps-block__right">
                              <router-link to="/login" >Login</router-link>

                            </div>
                        </div>
                          <div class="ps-block--user-account" v-if="loggedin"><i class="icon-user"></i>
                            <div class="ps-block__content">
                                <ul v-if="isEnglish()==true" class="ps-list--arrow">
                                    <li v-if="caller_role!='Basic'"><a href="/#/private">User management</a></li>
                                    <li v-if="caller_role!='Basic'"><a href="/#/invitations">Invitations</a></li>
                                    <li ><a href="/#/Userdetails">User account</a></li>
                                    <li><a href="/#/products">Products</a></li>
                                    <li><a href="/#/recipients">Recipients</a></li>
                                    <li class="ps-block__footer"> <router-link to="/login" >Logout</router-link></li>
                                </ul>
                                <ul v-if="isEnglish()==false" class="ps-list--arrow">
                                    <li v-if="caller_role!='Basic'"><a href="/#/private">Gestion des utilisateurs</a></li>
                                    <li v-if="caller_role!='Basic'"><a href="/#/invitations">Mes Invitations</a></li>
                                    <li ><a href="/#/Userdetails">Mon compte </a></li>
                                    <li><a href="/#/products">Produits</a></li>
                                    <li><a href="/#/recipients">Destinataires</a></li>
                                    <li class="ps-block__footer"> <router-link to="/login" >Déconnexion</router-link></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </header>
    <header class="header header--mobile" data-sticky="true">
        <div class="header__top">
            <div class="header__left">
                <p>Welcome to Martfury Online Shopping Store !</p>
            </div>
            <div class="header__right">
                <ul class="navigation__extra">
                    <li><a href="#">Sell on Martfury</a></li>
                    <li><a href="#">Track your order</a></li>

                    <li>
                        <div class="ps-dropdown language"><a href="#"><img src="./assets/img/flag/en.png" alt="">English</a>
                            <ul class="ps-dropdown-menu">
                                <li><a href="#"><img src="./assets/img/flag/germany.png" alt=""> Germany</a></li>
                                <li><a href="#"><img src="./assets/img/flag/fr.png" alt=""> France</a></li>
                            </ul>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="navigation--mobile">
            <div class="navigation__left"><a class="ps-logo" href="/#/private"><img src="./assets/img/logo-entreproamd-user.png" alt=""></a></div>
            <div class="navigation__right">
                <div class="header__actions">
                    <div class="ps-cart--mini"><a class="header__extra" href="#"><i class="icon-bag2"></i><span><i>0</i></span></a>
                        <div class="ps-cart__content">
                            <div class="ps-cart__items">
                                <div  v-for="item in cart" :key="item.id"  class="ps-product--cart-mobile">
                                    <div class="ps-product__thumbnail"><a href="#"><img :src="item.image_url" alt=""></a></div>
                                     <div class="ps-product__content">
                                            <a v-on:click="remove_from_cart(item)" class="ps-product__remove" href="#">
                                                <i  class="icon-cross">
                                                </i>
                                            </a>
                                            <a href="#products">{{item.description}}</a>
                                            <p>Quantity:<strong> {{item.minimum_quantity}}</strong></p>
                                            <small></small>
                                        </div>
                                </div>
                                <div class="ps-product--cart-mobile">
                                    <div class="ps-product__thumbnail"><a href="#"><img src="./assets/img/products/clothing/5.jpg" alt=""></a></div>
                                    <div class="ps-product__content"><a class="ps-product__remove" href="#"><i class="icon-cross"></i></a><a href="product-default.html">Sleeve Linen Blend Caro Pane Shirt</a>
                                        <!-- <p><strong>Sold by:</strong> YOUNG SHOP</p><small>1 x $59.99</small> -->
                                    </div>
                                </div>
                            </div>
                            <div class="ps-cart__footer">
                                <h3>Sub Total:<strong>$59.99</strong></h3>
                                <figure><a class="ps-btn" href="#products">View Cart</a><a class="ps-btn" href="#products">Checkout</a></figure>
                            </div>
                        </div>
                    </div>
                    <div class="ps-block--user-header">
                        <div class="ps-block__left">

                        </div>

                    </div>
                    <div class="ps-block--user-account" v-if="loggedin"><i class="icon-user"></i>
                            <div class="ps-block__content">
                                <ul v-if="isEnglish()==true" class="ps-list--arrow">
                                    <li v-if="caller_role!='Basic'"><a href="/#/private">User management</a></li>
                                    <li v-if="caller_role!='Basic'"><a href="/#/invitations">Invitations</a></li>
                                    <li ><a href="/#/Userdetails">User account</a></li>
                                    <li><a href="/#/products">Products</a></li>
                                    <li><a href="/#/recipients">Recipients</a></li>
                                    <li class="ps-block__footer"> <router-link to="/login" >Logout</router-link></li>
                                </ul>
                                  <ul v-if="isEnglish()==false" class="ps-list--arrow">
                                    <li v-if="caller_role!='Basic'"><a href="/#/private">Gestion des utilisateurs</a></li>
                                    <li v-if="caller_role!='Basic'"><a href="/#/invitations">Invitations</a></li>
                                    <li ><a href="/#/Userdetails">Mon compte</a></li>
                                    <li><a href="/#/products">Les produits</a></li>
                                    <li><a href="/#/recipients">Destinataires</a></li>
                                    <li class="ps-block__footer"> <router-link to="/login" >Deconnexion</router-link></li>
                                </ul>
                            </div>
                        </div>
                </div>
            </div>
        </div>
        <div class="ps-search--mobile">
            <form class="ps-form--search-mobile" action="/#/private" method="get">
                <div class="form-group--nest">
                    <input class="form-control" type="text" placeholder="Search something...">
                    <button><i class="icon-magnifier"></i></button>
                </div>
            </form>
        </div>
    </header>
    <div class="ps-panel--sidebar" id="cart-mobile">
        <div class="ps-panel__header">
            <h3>Shopping Cart</h3>
        </div>
        <div class="navigation__content">
            <div class="ps-cart--mobile">
                <div class="ps-cart__content">
                    <div class="ps-product--cart-mobile">
                        <div class="ps-product__thumbnail"><a href="#"><img src="./assets/img/products/clothing/7.jpg" alt=""></a></div>
                        <div class="ps-product__content"><a class="ps-product__remove" href="#"><i class="icon-cross"></i></a><a href="product-default.html">MVMTH Classical Leather Watch In Black</a>
                            <!-- <p><strong>Sold by:</strong> YOUNG SHOP</p><small>1 x $59.99</small> -->
                        </div>
                    </div>
                </div>
                <div class="ps-cart__footer">
                    <!-- <h3>Sub Total:<strong>$59.99</strong></h3> -->
                    <figure><a class="ps-btn" href="#products">View Cart</a><a class="ps-btn" href="#products">Checkout</a></figure>
                </div>
            </div>
        </div>
    </div>
    <div class="ps-panel--sidebar" id="navigation-mobile">
        <div class="ps-panel__header">
            <h3>Categories</h3>
        </div>
        <div class="ps-panel__content">
            <ul class="menu--mobile">
                <li><a href="#">Hot Promotions</a>
                </li>


            </ul>
        </div>
    </div>
    <div class="navigation--list">
        <div class="navigation__content"><a class="navigation__item ps-toggle--sidebar" href="#menu-mobile"><i class="icon-menu"></i><span> Menu</span></a><a class="navigation__item ps-toggle--sidebar" href="#navigation-mobile"><i class="icon-list4"></i><span> Categories</span></a><a class="navigation__item ps-toggle--sidebar" href="#search-sidebar"><i class="icon-magnifier"></i><span> Search</span></a><a class="navigation__item ps-toggle--sidebar" href="#cart-mobile"><i class="icon-bag2"></i><span> Cart</span></a></div>
    </div>
</div>



    <router-view :language="language" :search_on="search_on" :search_obj="search_obj" @headerAndFooter="showHeaderAndFooter"  @giveway="authenticate"/>


<div id="thefooter" v-if="showfooter">
     <footer class="ps-footer ps-footer--3">
        <div class="container">

            <div class="ps-block--site-features ps-block--site-features-2">
                <div class="ps-block__item">
                    <div class="ps-block__left"><i class="icon-rocket"></i></div>
                    <div class="ps-block__right">
                        <h4 v-if="isEnglish()==true">Free Delivery</h4>
                        <h4 v-if="isEnglish()!=true">Livraison gratuite</h4>
                    </div>
                </div>
                <div class="ps-block__item">
                    <div class="ps-block__left"><i class="icon-sync"></i></div>
                    <div class="ps-block__right">
                        <h4 v-if="isEnglish()==true">Online inventory</h4>
                        <h4 v-if="isEnglish()!=true">Inventaire en ligne</h4>
                    </div>
                </div>
                <div class="ps-block__item">
                    <div class="ps-block__left"><i class="icon-credit-card"></i></div>
                    <div class="ps-block__right">
                        <h4 v-if="isEnglish()==true">Secure website</h4>
                        <h4 v-if="isEnglish()!=true">Site sécuritaire</h4>
                    </div>
                </div>
                <div class="ps-block__item">
                    <div class="ps-block__left"><i class="icon-bubbles"></i></div>
                    <div class="ps-block__right">
                        <h4 v-if="isEnglish()==true" >Human contact</h4>
                        <h4 v-if="isEnglish()!=true" >Contact humain</h4>
                    </div>
                </div>
            </div>
            <div class="ps-footer__widgets">
                <aside class="widget widget_footer widget_contact-us" v-if="isEnglish()==true">
                    <h4 class="widget-title">Contact us</h4>
                    <div class="widget_content">
                        <p>At your beck and call</p>
                        <h3>T: 450 449-2312</h3>
                        <h3>F: 450 449-0127</h3>
                        <p>1440 Joliot-Curie Boucherville,<br/>
                        J4B 7L9 Québec, Canada<br>
                        <a href="mailto:entrepro@entreproamd.com">entrepro@entreproamd.com</a></p>
                        <!--<ul class="ps-list--social">
                            <li><a class="facebook" href="#"><i class="fa fa-facebook"></i></a></li>
                            <li><a class="twitter" href="#"><i class="fa fa-twitter"></i></a></li>
                            <li><a class="google-plus" href="#"><i class="fa fa-google-plus"></i></a></li>
                            <li><a class="instagram" href="#"><i class="fa fa-instagram"></i></a></li>
                        </ul>//-->
                    </div>
                </aside>
                <aside class="widget widget_footer widget_contact-us"  v-if="isEnglish()!=true">
                    <h4 class="widget-title">Contactez-nous</h4>
                    <div class="widget_content">
                        <p>À votre service</p>
                        <h3>T: 450 449-2312</h3>
                        <h3>F: 450 449-0127</h3>
                        <p>1440 Joliot-Curie Boucherville,<br/>
                        J4B 7L9 Quebec, Canada<br>
                        <a href="mailto:entrepro@entreproamd.com">entrepro@entreproamd.com</a></p>
                        <!--<ul class="ps-list--social">
                            <li><a class="facebook" href="#"><i class="fa fa-facebook"></i></a></li>
                            <li><a class="twitter" href="#"><i class="fa fa-twitter"></i></a></li>
                            <li><a class="google-plus" href="#"><i class="fa fa-google-plus"></i></a></li>
                            <li><a class="instagram" href="#"><i class="fa fa-instagram"></i></a></li>
                        </ul>//-->
                    </div>
                </aside>
                <aside class="widget widget_footer">
                    <h4 class="widget-title">Services</h4>
                    <ul class="ps-list--link" v-if="isEnglish()!=true">
                        <li><a href="https://www.entreproamd.com/index.php/2014/01/01/logistique/" target="_blank">Logistique</a></li>
                        <li><a href="https://www.entreproamd.com/index.php/2014/01/02/manutention/" target="_blank">Manutention</a></li>
                        <li><a href="https://www.entreproamd.com/index.php/2014/01/03/distribution/" target="_blank">Distribution</a></li>
                        <li><a href="https://www.entreproamd.com/index.php/2014/01/04/logistique-3pl/" target="_blank">3PL, B2B & B2C</a></li>
                        <li><a href="https://www.entreproamd.com/index.php/2014/01/05/e-commerce/" target="_blank">E-commerce</a></li>
                        <li><a href="https://www.entreproamd.com/index.php/2014/01/06/transport/" target="_blank">Transport</a></li>
                        <li><a href="https://www.entreproamd.com/index.php/2014/01/09/gestion-inventaire/" target="_blank">Gestion d'inventaire</a></li>
                        <li><a href="https://www.entreproamd.com/index.php/2014/01/10/entreposage/" target="_blank">Entreprosage</a></li>
                    </ul>

                    <ul class="ps-list--link" v-if="isEnglish()==true">
                        <li><a href="https://www.entreproamd.com/index.php/2017/10/26/logistics/" target="_blank">Logistics</a></li>
                        <li><a href="https://www.entreproamd.com/index.php/2017/10/26/handling/" target="_blank">Handling</a></li>
                        <li><a href="https://www.entreproamd.com/index.php/2017/10/26/distribution-2/" target="_blank">Distribution</a></li>
                        <li><a href="https://www.entreproamd.com/index.php/2017/10/25/3pl-b2b-b2c/" target="_blank">3PL, B2B & B2C</a></li>
                        <li><a href="https://www.entreproamd.com/index.php/2014/01/05/e-commerce/" target="_blank">E-commerce</a></li>
                        <li><a href="https://www.entreproamd.com/index.php/2017/10/16/e-commerce-en/" target="_blank">Transport</a></li>
                        <li><a href="https://www.entreproamd.com/index.php/2017/10/16/gestion-dinventaire-en/" target="_blank">Inventory managment</a></li>
                        <li><a href="https://www.entreproamd.com/index.php/2017/10/16/entreprosage-en/" target="_blank">Storage</a></li>
                    </ul>
                </aside>
                <aside class="widget widget_footer"  v-if="isEnglish()!=true">
                    <h4 class="widget-title">Compagnie</h4>
                    <ul class="ps-list--link">
                        <li><a href="https://www.entreproamd.com/">Nouvelles</a></li>
                        <li><a href="https://www.entreproamd.com/index.php/contact/">Contact us</a></li>
                    </ul>
                </aside>
                 <aside class="widget widget_footer" v-if="isEnglish()==true">
                    <h4 class="widget-title">Company</h4>
                    <ul class="ps-list--link">
                        <li><a href="http://www.entreproamd.com/index.php/accueil-en-4/">News</a></li>
                        <li><a href="https://www.entreproamd.com/index.php/contact-en/">Contact us</a></li>
                    </ul>
                </aside>
            </div>

            <div class="ps-footer__copyright">
                <p v-if="isEnglish()==true">© <span id="copyright-year">{{ currentYear }}</span> All Rights Reserved</p>
                <p v-if="isEnglish()==false">© <span id="copyright-year">{{ currentYear }}</span> Tous droits réservés</p>
                <!--<p><span>We Using Safe Payment For:</span><a href="#"><img src="./assets/img/payment-method/1.jpg" alt=""></a><a href="#"><img src="img/payment-method/2.jpg" alt=""></a><a href="#"><img src="img/payment-method/3.jpg" alt=""></a><a href="#"><img src="img/payment-method/4.jpg" alt=""></a><a href="#"><img src="img/payment-method/5.jpg" alt=""></a></p>//-->

            </div>
        </div>
    </footer>
    <div id="back2top"><i class="icon icon-arrow-up"></i></div>
    <div class="ps-site-overlay"></div>
    <div id="loader-wrapper">
        <div class="loader-section section-left"></div>
        <div class="loader-section section-right"></div>
    </div>
    <div class="ps-search" id="site-search"><a class="ps-btn--close" href="#"></a>
        <div class="ps-search__content">
            <form class="ps-form--primary-search" action="do_action" method="post">
                <input class="form-control" type="text" placeholder="Search for...">
                <button><i class="aroma-magnifying-glass"></i></button>
            </form>
        </div>
    </div>
</div>



  </div>
</template>

<script>
import Products from './components/Products'
import DataService from "./services/DataService";

export default {
components: {
     'user-products': Products
  },
  name: 'App',
   data () {
    return {
      showfooter : true,
      showheader : true,
      loggedin : false,
      showeventmsg :false,
      showerrormsg :false,
      eventmsg : "",
      token:localStorage.getItem('token'),
      company: localStorage.getItem('company'),
      caller_role:localStorage.getItem('caller_role'),
      clicked :false,
      cart:[],
      language: {id:1,language:"English", href:"./assets/img/flag/en.png",value:"en"},
      languages :[{id:1,language:"English", href:"./assets/img/flag/en.png",value:"en"},{id:2,language:"Français", href:"./assets/img/flag/fr.png",value:"fr"}],
      search_type : ["Division","Product"],
      key:0,
      search_on:false,

      search_obj:{type:"",word:""},

      currentYear:""


    }
  },
  methods:{


       showHeaderAndFooter(boo){

        if(boo===true){
           this.showheader = true;
           this.showfooter = true;
        }else if(boo===false){
           this.showheader = false;
           this.showfooter = false;
           }
       },

       authenticate(boo){
        if(boo===true){
           this.loggedin = true;
           localStorage.setItem('token',this.token);

           this.showHeaderAndFooter(true);
        }else if(boo===false){
            this.loggedin = false;
            localStorage.setItem('token', '');
            localStorage.setItem('basket', '');
            localStorage.setItem('caller_role', '')
            this.showHeaderAndFooter(false);
        }

       },

       search_product(){
        console.log("yeah yeah yeah");
        this.search_on = true;

        //console.log(this.search_obj);
       },

       remove_from_cart(item){

       var removeIndex = this.cart.map(function(item) { return item.id; }).indexOf(item.id);
       this.cart.splice(removeIndex,1);
        console.log(this.cart);

        localStorage.setItem('basket',JSON.stringify(this.cart));

       this.clicked = true;

        setTimeout(function(){
        this.clicked = false;
       }.bind(this),1000);

       },



       change_user_language(lang){

        var token = localStorage.getItem('token');
        var dataa = {language:lang};
        console.log(dataa);
        DataService.change_user_language(dataa,token)
          .then(response => {

            console.log(response);

        if(lang=="en"){

           this.language = this.languages[0];
           localStorage.setItem('lang', 'en');
           this.$parent.language = this.languages[0];

        }else if(lang=="fr"){
           this.language = this.languages[1];
            localStorage.setItem('lang', 'fr');
           this.$parent.language = this.languages[1];
        }

          })
          .catch(e => {
            console.log(e.response);

          });
       },

       isEnglish(){

            let lang = localStorage.getItem('lang');
            if(lang=='en'){

            return true;

            }else if(lang=='fr'){

            return false;

            }else{

            return true;

            }

       },




       translate_error_message(err_obj,type){

         let lang = localStorage.getItem('lang');
         //let type = type;

         if(lang==='en'){

           if(type==="message"){

             return err_obj.message;

           }else if(type==="errors"){

              return Array.isArray(err_obj) ? err_obj.join(' ') : err_obj;
           }

         }else if(lang==='fr'){

           if(type==="message"){

            return err_obj.message2;

           }else if(type==="errors"){

              return Array.isArray(err_obj) ? err_obj.join(' ') : err_obj;
           }
         }else{

              if(type==="message"){

            return err_obj.message;

           }else if(type==="errors"){

              return Array.isArray(err_obj) ? err_obj.join(' ') : err_obj;
           }
         }


       },



       doAction(event){
          console.log("printing the input change:");
          console.log(event);
           if (event.key == "Enter") {
                // Cancel the default action, if needed
                event.preventDefault();
                console.log("printing the enter key");
           }
       }

},








  mounted(){

      if( localStorage.getItem('token')=="" ||  localStorage.getItem('token')==null ){

        this.loggedin = false;

      }else{

        this.token = localStorage.getItem('token');
        this.loggedin = true;

       if( localStorage.getItem('basket')!="" &&  localStorage.getItem('basket')!=null){

        this.cart = JSON.parse(localStorage.getItem('basket')) ;

        }

        this.token = localStorage.getItem('token')
        this.loggedin = true;

      }


      if(localStorage.getItem('lang')!=null && localStorage.getItem('lang')!=''){

          if(localStorage.getItem('lang')=='en'){

               this.language = this.languages[0];

          }else if(localStorage.getItem('lang')=='fr'){

               this.language = this.languages[1];
          }

      }else{
         this.language = {id:1,language:"English", href:"./assets/img/flag/en.png",value:"en"};
      }

      let currentDate = new Date()
      this.currentYear = currentDate.getFullYear();
  }



}


</script>

<style>
@import './assets/plugins/font-awesome/css/font-awesome.min.css';
@import './assets/fonts/Linearicons/Linearicons/Font/demo-files/demo.css';
@import './assets/plugins/bootstrap/css/bootstrap.min.css';
@import './assets/plugins/owl-carousel/assets/owl.carousel.min.css';
@import './assets/plugins/owl-carousel/assets/owl.theme.default.min.css';
@import './assets/plugins/slick/slick/slick.css';
@import './assets/plugins/nouislider/nouislider.min.css';
@import './assets/plugins/lightGallery-master/dist/css/lightgallery.min.css';
@import './assets/plugins/jquery-bar-rating/dist/themes/fontawesome-stars.css';
@import './assets/plugins/select2/dist/css/select2.min.css';
@import './assets/css/style.css';
@import './assets/css/market-place-4.css';
@import './assets/css/custom.css';
/* @import 'https://cdn.datatables.net/1.10.24/css/jquery.dataTables.min.css'; */
</style>



// WEBPACK FOOTER //
// src/App.vue